
import { useEffect } from "react";
import { useDealerSwitch,} from "@gplibraries/react/hooks";
import { PageTitle, Breadcrumbs, DealerMaskMessage } from '@gplibraries/react/components';

const DealerMorphPage = () => {
  const switchDealer = useDealerSwitch();

  useEffect(() => {
    switchDealer();
  }, []);

  return (
    <div >
        <Breadcrumbs/>
        <DealerMaskMessage/>
      <PageTitle>Switch Dealer</PageTitle>
      <button onClick={switchDealer}>Switch Dealer</button>
    </div>
  );
};

export default DealerMorphPage;

